import React, { useRef, useState, useEffect, useContext } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import send from "../../Assets/Images/send.png";
import axios from "axios";
import {
  showToast,
  WEBSERVICE,
  checkCurrencyPairAccreditedStatus,
} from "../../CoreDataService";
import { useNavigate } from "react-router-dom";
import InfoPopUp from "../../Common/InfoPopUp";
import { DataContext } from ".";
import TelegramIcon from "@mui/icons-material/Telegram";
import InfoIcon from "@mui/icons-material/Info";
import AccreditationVerificationPopup from "../Accredited-Kyc/AccreditationVerificationPopup";
import TermsAgreementPopup from "../Accredited-Kyc/TermsAgreementPopup";
import { showErrorDialog } from "../../CoreDataService";

const title = "Limit";
const description = `You can create Buy and Sell limit offers at the price of your
              choice and the offers will reflect in Order Book and Open Orders.
              Enter "Amount", and Price and click on the BUY button for the BUY
              offer. Enter "Amount", and Price and click on the SELL button for
              the SELL offer.`;

const BuyAndSellLimit = ({
  selectedBuyingAssetBalance,
  selectedSellingAssetBalance,
  percentageValue,
  getUserTransaction,
  selectedOrderType,
  minBuySellAmount,
}) => {
  const {
    currencycode,
    basecurrency,
    sellData,
    buyData,
    setUpdateOrder,
    lastAskItem,
    firstBidItem,
  } = useContext(DataContext);

  const theme = localStorage.getItem("theme");
  const tradep = localStorage.getItem("priceprc") || 6;
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const progressBarRef = useRef(null);
  const [sliderValue, setSliderValue] = useState(0);
  const sliderRef = useRef(null);
  const steps = [0, 25, 50, 75, 100];
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleClose = () => setShow(false);

  const [limitAmount, setLimitAmount] = useState();
  const [limitPrice, setLimitPrice] = useState("");
  const [limitAmountForOco1, setLimitAmountForOco1] = useState(0);
  const [limitPriceForOco1, setLimitPriceForOco1] = useState(0);
  const [limittriggerForOco1, setLimitTriggerForOco1] = useState(0);
  const [limitAmountForOco2, setLimitAmountForOco2] = useState(0);
  const [limitPriceForOco2, setLimitPriceForOco2] = useState(0);
  const [limittriggerForOco2, setLimitTriggerForOco2] = useState(0);
  const [isPlaceOrderEnabled, setIsPlaceOrderEnabled] = useState(false);
  const [isPlaceOrderEnabledForSell, setIsPlaceOrderEnabledForSell] =
    useState(false);
  const [limitValue, setLimitValue] = useState("");
  const [sliderValueBuy, setSliderValueBuy] = useState(0);
  const [sliderValueSell, setSliderValueSell] = useState(0);
  const [sliderValueBuyLimit, setSliderValueBuyLimit] = useState(0);
  const [sliderValueSellLimit, setSliderValueSellLimit] = useState(0);
  const [error, setError] = useState(false);

  const [limitAmountSell, setLimitAmountSell] = useState("");
  const [limitPriceSell, setLimitPriceSell] = useState("");
  const [limitValueSell, setLimitValueSell] = useState("");
  const [stpLoader, setStpLoader] = useState(false);
  const [showAccreditedPopup, setShowAccreditedPopup] = useState(false);
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [termsLinks, setTermsLinks] = useState([]);
  const [pendingProceed, setPendingProceed] = useState(null);
  const [pendingTxnType, setPendingTxnType] = useState(null);

  useEffect(() => {
    if (lastAskItem && lastAskItem.price && limitAmount) {
      const price = parseFloat(lastAskItem.price);
      const newPrice = (price - price * 0.02).toFixed(tradep);
      setLimitPrice(newPrice);
    }
  }, [lastAskItem, limitAmount]);

  useEffect(() => {
    if (firstBidItem && firstBidItem.price && limitAmountSell) {
      const price = parseFloat(firstBidItem.price);
      console.log("firstBidItem price----->>>", price);
      const newPrice = (price + price * 0.02).toFixed(tradep);
      console.log("firstBidItem price----->>> newPrice", newPrice);
      setLimitPriceSell(newPrice);
    }
  }, [firstBidItem, limitAmountSell]);

  useEffect(() => {
    checkUserBlockStatus();
  }, []);
  // useEffect(() => {
  //   setLimitPrice(buyData);
  //   const value = parseFloat(limitAmount) * parseFloat(buyData);
  //   setLimitValue(isNaN(value) ? "" : value.toFixed(tradep));
  //   resetSliderBuy();
  // }, [buyData]);
  // useEffect(() => {
  //   setLimitPriceSell(sellData);
  //   const valueSell = parseFloat(limitAmountSell) * parseFloat(sellData);
  //   setLimitValueSell(isNaN(valueSell) ? "" : valueSell.toFixed(tradep));
  //   resetSliderSell();
  // }, [sellData]);

  const checkUserBlockStatus = async () => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    if (!uuid || !accessToken) {
      showToast("error", "Session Timeout. Login Again");
      //logout
      return false;
    }

    const payload = { uuid };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/userAccountStatus`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      if (response.data?.error?.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
        return false;
      }

      if (response.data.status !== 1) {
        showToast("error", "Your user has been blocked by Admin");
        return false;
      }

      return true;
    } catch (error) {
      if (error.response?.status === 401) {
        showToast("error", "Session Timeout. Login Again");
        //logout
      }
      return false;
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };
  const getAssetCode = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset ? asset.assetCode : "";
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return "";
    }
  };

  /* Get base and counter ID of a pair */
  const getAssetId = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset
        ? { baseCurrencyId: asset.baseCurrencyId, currencyId: asset.currencyId }
        : {};
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return {};
    }
  };

  const resetSliderBuy = () => {
    setProgress(0);
  };
  const resetSliderSell = () => {
    setSliderValue(0);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
    if (regex.test(value)) {
      setLimitAmount(value);
    }
  };

  const handleKeyUp = () => {
    validateLimit();
    resetSliderBuy();
    calculateLimitTotalFromAmount();
  };

  const validateLimit = () => {
    if (limitAmount < minBuySellAmount?.minBuyQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minBuyQty}`
      );
      setLimitValue(0);
      // document.getElementById("mbuy").disabled = true;
      return;
    }
    placeOrderForOcoBuy();
    placeOrderForOcoSell();
    // const isInvalid = limitAmount <= 0.0001 || limitPrice <= 0.00000001;
    // setError(isInvalid);
    // return isInvalid;
  };

  const placeOrderForOcoBuy = () => {
    if (selectedOrderType === "OCO") {
      // if (
      //   limitAmount <= 0.0001 ||
      //   limitPrice <= 0 ||
      //   limitAmountForOco1 <= 0.0001 ||
      //   limitPriceForOco1 <= 0 ||
      //   limittriggerForOco1 <= 0.0001
      // ) {
      //   setIsPlaceOrderEnabled(false);
      // } else {
      //   setIsPlaceOrderEnabled(true);
      // }
    }
  };

  const placeOrderForOcoSell = () => {
    if (selectedOrderType === "OCO") {
      // if (
      //   limitAmount <= 0.0001 ||
      //   limitPrice <= 0 ||
      //   limitAmountForOco2 <= 0.0001 ||
      //   limitPriceForOco2 <= 0 ||
      //   limittriggerForOco2 <= 0.0001
      // ) {
      //   setIsPlaceOrderEnabledForSell(false);
      // } else {
      //   setIsPlaceOrderEnabledForSell(true);
      // }
    }
  };

  const calculateLimitTotalFromAmount = () => {
    const total = (limitAmount * limitPrice).toFixed(8);
    setLimitValue(isNaN(total) ? "" : total);
  };

  const calculateAmountFromLimitForLimit = (type) => {
    if (type === "buy") {
      const value = parseFloat(limitAmount) * parseFloat(limitPrice);
      setLimitValue(isNaN(value) ? "" : value.toFixed(tradep));
      resetSliderBuy();
    } else {
      const valueSell =
        parseFloat(limitPriceSell) * parseFloat(limitAmountSell);
      setLimitValueSell(isNaN(valueSell) ? "" : valueSell.toFixed(tradep));
      resetSliderSell();
    }
    if (isNaN(limitAmount)) {
      setLimitAmount("");
    }
    if (isNaN(limitAmountSell)) {
      setLimitAmountSell("");
    }
  };

  const calculateAmountFromTotalForLimit = async (type, e) => {
    let inputValue = e.target.value;
    let buyingCrypto = currencycode;
    let sellingCrypto = basecurrency;
    let accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${buyingCrypto}${sellingCrypto}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const data = response.data;
      let price, amount;
      if (type === "buy") {
        price = (
          parseFloat(data.ask[0].price) -
          parseFloat(data.ask[0].price) * 0.01
        ).toFixed(8);
        amount = (parseFloat(inputValue) / parseFloat(price)).toFixed(8);
        // setLimitPrice(price);
        setLimitAmount(isNaN(amount) ? "" : amount);
      } else {
        price = (
          parseFloat(data.bid[0].price) +
          parseFloat(data.bid[0].price) * 0.01
        ).toFixed(8);
        amount = (parseFloat(inputValue) / parseFloat(price)).toFixed(8);
        // setLimitPriceSell(price);
        setLimitAmountSell(isNaN(amount) ? "" : amount);
      }

      // const isDisabled = isNaN(amount) || parseFloat(amount) < 0.0001;
      //   document.querySelector(".onlyBuyBtn").disabled = isDisabled;
      //   document.querySelector(".onlySellBtn").disabled = isDisabled;
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const handleProgressChange = (event) => {
    if (!progressBarRef.current) return;

    const { left, width } = progressBarRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setProgress(closestStep);
    handleSliderChange(closestStep);
  };

  const handleSliderChange = async (sliderValue) => {
    setStpLoader(true);
    let buyingCrypto = currencycode;
    let sellingCrypto = basecurrency;
    let accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${buyingCrypto}${sellingCrypto}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      let askPrice = parseFloat(response.data.ask[0].price);
      let calculatedLimitAmount = (
        (selectedSellingAssetBalance * (sliderValue / 100) -
          selectedSellingAssetBalance * (sliderValue / 100) * percentageValue) /
        askPrice
      ).toFixed(tradep);
      let calculatedLimitPrice =
        sliderValue === 0 ? 0 : (askPrice - askPrice * 0.01).toFixed(tradep);
      let calculatedLimitValue = (
        calculatedLimitAmount * calculatedLimitPrice
      ).toFixed(tradep);

      setLimitAmount(calculatedLimitAmount);
      setLimitPrice(calculatedLimitPrice);
      setLimitValue(calculatedLimitValue);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }

    setStpLoader(false);
  };

  const handleLimitBuy = async () => {
    setLoading(true);
    // data.alert("Loading...", "dark", 30000);

    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      currencycode?.toUpperCase(),
      basecurrency?.toUpperCase(),
      "BUY",
      limitAmount
    );

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doLimitBuy();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(1);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doLimitBuy = async () => {
    setLoading(true);

    let inputObj = {
      selling_asset_code: currencycode?.toUpperCase(),
      buying_asset_code: basecurrency?.toUpperCase(),
      userId: localStorage.getItem("userId"),
      price: limitPrice,
      txn_type: "1",
    };

    if (limitPrice * limitAmount > 0) {
      if (limitAmount && limitPrice) {
        inputObj = {
          selling_asset_code: basecurrency?.toUpperCase(),
          buying_asset_code: currencycode?.toUpperCase(),
          amount: limitAmount,
          price: limitPrice,
          txn_type: "1",
          offerType:
            selectedOrderType === "FOK" || selectedOrderType === "IOC"
              ? "M"
              : "L",
          orderType:
            selectedOrderType !== "GTC" ? selectedOrderType : undefined,
          assetCode: getAssetCode(currencycode, basecurrency),
          baseCurrencyId: getAssetId(currencycode, basecurrency)[
            "baseCurrencyId"
          ],
          currencyId: getAssetId(currencycode, basecurrency)["currencyId"],
          uuid: localStorage.getItem("uuid"),
        };

        try {
          const response = await axios.post(
            `${WEBSERVICE}userTrade/TradeCreateOffer`,
            JSON.stringify(inputObj),
            {
              headers: {
                "Content-Type": "application/json",
                authorization: `BEARER ${localStorage.getItem("access_token")}`,
              },
            }
          );

          showToast(
            response.data.error.error_data !== 0 ? "danger" : "success",
            response.data.error.error_msg
          );
          setLimitPrice("");
          setLimitAmount("");
          setLimitValue("");
          setProgress(0);
          getUserTransaction();
          setUpdateOrder((prev) => !prev);

          if (localStorage.getItem("tradeNavHist") === "open") {
            // data.renderDataForMyOfferSpot();
          } else if (localStorage.getItem("tradeNavHist") === "stop") {
            // data.renderDataForStopLimitSpot("buy");
          } else {
            localStorage.setItem("isTimeToRenderSpotMyTrade", "true");
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          showToast("error", "Error placing order");
        }
      } else {
        setLoading(false);
        showToast("warning", "Please provide proper buying details");
      }
    } else {
      setLoading(false);
      showToast("warning", "Your offer is too small");
    }

    setLoading(false);
  };

  const handleChangeLimitmoutSell = (event) => {
    const value = event.target.value;
    const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
    if (regex.test(value)) {
      setLimitAmountSell(value);
    }
  };

  const validateLimitSell = () => {
    placeOrderForOcoBuy();
    placeOrderForOcoSell();

    if (limitAmountSell < minBuySellAmount?.minSellQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minSellQty}`
      );
      setLimitValueSell(0);
      // document.getElementById("mbuy").disabled = true;
      return;
    }

    // if (limitAmountSell <= 0.0001) {
    //   //   document.querySelector('.onlySellError2')?.classList.add('show');
    //   disableButtons(true);
    // } else {
    //   //   document.querySelector('.onlySellError2')?.classList.remove('show');
    //   disableButtons(false);
    // }
    // return 0.0001 >= limitAmountSell || 0.00000001 >= limitPriceSell;
  };

  const calculateLimitTotalFromAmountSell = () => {
    const total = (limitAmountSell * limitPriceSell).toFixed(8);
    setLimitValueSell(isNaN(total) ? "" : total);
  };

  const disableButtons = (disable) => {
    // document.getElementById('mbuy')?.setAttribute('disabled', disable);
    // document.getElementById('msell')?.setAttribute('disabled', disable);
    // document.getElementById('onlySellBtn')?.setAttribute('disabled', disable);
  };

  const handleSliderInteraction = (event) => {
    if (!sliderRef.current) return;

    const { left, width } = sliderRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setSliderValue(closestStep);
    getSellValSlider(closestStep);
  };

  const getSellValSlider = async (sliderValues) => {
    // setLoading(true);
    let newSellBalanceLimit = parseFloat(selectedBuyingAssetBalance);
    let newLimitAmountSell = newSellBalanceLimit * (sliderValues / 100);
    setLimitAmountSell(newLimitAmountSell);

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${currencycode}${basecurrency}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const bidPrice = parseFloat(response.data.bid[0].price);
      const newLimitPriceSell =
        sliderValues === 0 ? 0 : (bidPrice + bidPrice * 0.01).toFixed(tradep);
      setLimitPriceSell(newLimitPriceSell);

      setLimitValueSell(
        (newLimitAmountSell * newLimitPriceSell).toFixed(tradep)
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      //   setLoading(false);
    }
  };

  const limitSell = async () => {
    setIsLoading(true);

    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      currencycode?.toUpperCase(),
      basecurrency?.toUpperCase(),
      "SELL",
      limitAmountSell
    );

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doLimitSell();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(2);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doLimitSell = async () => {
    try {
      setIsLoading(true);

      if (limitPriceSell && limitAmountSell) {
        const inputObj = {
          amount: limitAmountSell,
          selling_asset_code: currencycode?.toUpperCase(),
          buying_asset_code: basecurrency?.toUpperCase(),
          userId: localStorage.getItem("userId"),
          price: limitPriceSell,
          txn_type: "2",
          offerType:
            selectedOrderType === "FOK" || selectedOrderType === "IOC"
              ? "M"
              : "L",
          orderType:
            selectedOrderType !== "GTC" ? selectedOrderType : undefined,
          assetCode: getAssetCode(currencycode, basecurrency),
          baseCurrencyId: getAssetId(currencycode, basecurrency).baseCurrencyId,
          currencyId: getAssetId(currencycode, basecurrency).currencyId,
          uuid: localStorage.getItem("uuid"),
        };

        if (limitPriceSell * limitAmountSell > 0) {
          const response = await axios.post(
            `${WEBSERVICE}userTrade/TradeCreateOffer`,
            inputObj,
            {
              headers: {
                "Content-Type": "application/json",
                authorization: `BEARER ${localStorage.getItem("access_token")}`,
              },
            }
          );

          const result = response.data;
          console.log("result---->>>>", result);

          if (result.error.error_data !== 0) {
            if (result.error.error_data === 2) {
              showErrorDialog(result);
            } else {
              showToast("error", result.error.error_msg);
            }
            setIsLoading(false);
          } else {
            showToast("success", result.error.error_msg);
            localStorage.setItem("isTimeToRenderSpotMyTrade", "true");
            setLimitAmountSell("");
            setLimitPriceSell("");
            setLimitValueSell("");
            setSliderValue(0);
            getUserTransaction();
            setUpdateOrder((prev) => !prev);
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
          showToast("warning", "Your offer is too small");
        }
      } else {
        setIsLoading(false);
        showToast("warning", "Please provide proper selling details");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      showToast("error", error?.response?.data?.error?.error_msg);
      console.error("Error in limitSell:", error);
    } finally {
      setIsLoading(false);
      // document.querySelectorAll('.onlyBuyBtn, .onlySellBtn, .tradeBtn').forEach(btn => btn.disabled = false);
    }
  };

  const checkNumber = (num) => (isNaN(num) ? 0 : num);

  return (
    <div>
      <div className="trade-wrap">
        {/* ── BUY PANEL ── */}
        <div className="trade-panel trade-panel-buy">
          <div className="trade-side-label buy-label">
            Buy {currencycode?.toUpperCase()}
          </div>

          <div className="trade-bal-row">
            <span className="bal-amount">
              {selectedSellingAssetBalance} {basecurrency?.toUpperCase()}
            </span>
            <span className="bal-actions">
              <span
                className="deposit-withdraw-btn"
                style={{ position: "relative" }}
              >
                {basecurrency?.toUpperCase() === "USD" ? (
                  <span className="diposit-hover">DEPOSIT</span>
                ) : (
                  <span className="diposit-hover">RECEIVE</span>
                )}
                <TelegramIcon
                  style={{
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    width: 16,
                    height: 16,
                    opacity: 0.55,
                  }}
                  onClick={() => navigate("/my-wallet")}
                />
              </span>
              <InfoIcon
                style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }}
                onClick={() => setShow(true)}
              />
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder={minBuySellAmount?.minBuyQty}
                value={limitAmount}
                onChange={handleChange}
                onKeyUp={handleKeyUp}
                required
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Price</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(limitPrice)}
                onChange={(e) => setLimitPrice(e.target.value)}
                onKeyUp={() => {
                  validateLimit();
                  calculateAmountFromLimitForLimit("buy");
                }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(limitValue)}
                onChange={(e) => setLimitValue(e.target.value)}
                onKeyUp={(event) => {
                  calculateAmountFromTotalForLimit("buy", event);
                  resetSliderBuy();
                }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={progressBarRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${
                  progress === pct ? "pct-active-buy" : ""
                }`}
                onClick={() => {
                  setProgress(pct);
                  handleSliderChange(pct);
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-buy"
            disabled={
              !(limitValue > 0) ||
              loading ||
              limitAmount < minBuySellAmount?.minBuyQty
            }
            onClick={handleLimitBuy}
          >
            {loading ? "Loading..." : `BUY ${currencycode?.toUpperCase()}`}
          </button>
        </div>

        {/* ── SELL PANEL ── */}
        <div className="trade-panel">
          <div className="trade-side-label sell-label">
            Sell {currencycode?.toUpperCase()}
          </div>

          <div className="trade-bal-row">
            <span className="bal-amount">
              {selectedBuyingAssetBalance} {currencycode?.toUpperCase()}
            </span>
            <span className="bal-actions">
              <span
                className="deposit-withdraw-btn"
                style={{ position: "relative" }}
              >
                {basecurrency?.toUpperCase() === "USD" ? (
                  <span className="diposit-hover">DEPOSIT</span>
                ) : (
                  <span className="diposit-hover">RECEIVE</span>
                )}
                <TelegramIcon
                  style={{
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    width: 16,
                    height: 16,
                    opacity: 0.55,
                  }}
                  onClick={() => navigate("/my-wallet")}
                />
              </span>
              <InfoIcon
                style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }}
                onClick={() => setShow(true)}
              />
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder={minBuySellAmount?.minSellQty}
                value={limitAmountSell}
                onChange={(e) => handleChangeLimitmoutSell(e)}
                onKeyUp={() => {
                  validateLimitSell();
                  resetSliderSell();
                  calculateLimitTotalFromAmountSell();
                }}
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Price</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(limitPriceSell)}
                onChange={(e) => setLimitPriceSell(e.target.value)}
                onKeyUp={() => {
                  validateLimitSell();
                  calculateAmountFromLimitForLimit("sell");
                }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(limitValueSell)}
                onChange={(e) => setLimitValueSell(e.target.value)}
                onKeyUp={(event) => {
                  calculateAmountFromTotalForLimit("sell", event);
                  resetSliderSell();
                }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={sliderRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${
                  sliderValue === pct ? "pct-active-sell" : ""
                }`}
                onClick={() => {
                  setSliderValue(pct);
                  getSellValSlider(pct);
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-sell"
            disabled={
              !(limitValueSell > 0) ||
              isLoading ||
              limitAmountSell < minBuySellAmount?.minSellQty
            }
            onClick={limitSell}
          >
            {isLoading ? "Loading..." : `SELL ${currencycode?.toUpperCase()}`}
          </button>
        </div>
      </div>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={title}
        description={description}
      />
      <AccreditationVerificationPopup
        open={showAccreditedPopup}
        onClose={() => setShowAccreditedPopup(false)}
        theme={localStorage.getItem("theme")}
      />
      <TermsAgreementPopup
        open={showTermsPopup}
        onClose={() => {
          setShowTermsPopup(false);
          setPendingProceed(null);
        }}
        onProceed={() => {
          if (typeof pendingProceed === "function") {
            pendingProceed();
          }
          setPendingProceed(null);
        }}
        links={termsLinks}
        theme={localStorage.getItem("theme")}
        vestingCurrency={currencycode}
        txnType={pendingTxnType}
      />
    </div>
  );
};

export default BuyAndSellLimit;
